import { MockHook, urls } from '@jupiterone/jupiter-web-toolkit';
import { useCurrentOEMBrandingEntitlements } from '@jupiterone/jupiter-web-toolkit/src/entitlements/useValueSetEntitlementAccess';
import { CurrentOEMBranding } from '@jupiterone/entitlement-types';

const mapping: Record<CurrentOEMBranding, string> = {
  [CurrentOEMBranding.CISCO]: urls.oemLogoCisco,
};

const useCurrentOEMBrandingLogoLogic = () => {
  const oemBrandingEntitlement = useCurrentOEMBrandingEntitlements();
  const loading = Boolean(oemBrandingEntitlement?.loading);
  const branding = oemBrandingEntitlement?.data?.checkValueSetEntitlementAccess.items.find(
    (brand) => brand.canAccess
  );
  const currentOEMBrandingLogo: string | false =
    (branding?.value && mapping[branding.value]) ?? false;

  return {
    loading,
    currentOEMBrandingLogo,
  };
};

export type CurrentOEMBrandingLogoComponentProps = ReturnType<
  typeof useCurrentOEMBrandingLogoLogic
>;

export const MOCK_CURRENT_O_E_M_BRANDING_LOGO_PROPS: CurrentOEMBrandingLogoComponentProps = {
  loading: false,
  currentOEMBrandingLogo: mapping[CurrentOEMBranding.CISCO],
};

export default MockHook.useMockHook(
  useCurrentOEMBrandingLogoLogic,
  MOCK_CURRENT_O_E_M_BRANDING_LOGO_PROPS
);
